export const formatRatingAverage = number => {
  const formattedRatingNum = number === null ? 0 : number
  return parseFloat(Math.round(formattedRatingNum * 10) / 10).toFixed(1)
}

export const formatNumberWithPeriods = (number = 0) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const formatAvatarInitials = (name = '') =>
  name
    .split(/[/ -]/)
    .slice(0, 2)
    .map(n => n[0])
    .join('')

export const thousandSeparator = text => String(text).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const formatNumber = (number = 0) => {
  if (number === null || number === 0) {
    return '0'
  }
  if (typeof number === 'string') {
    return number
  }
  return thousandSeparator(number)
}

// https://stackoverflow.com/a/9461657
export const kFormatter = num => {
  return num >= 1000 ? `${Math.trunc(num / 100) / 10}K` : num
}

export const priceFormatter = price => {
  return price && price.includes('.00') ? price.split('.')[0] : price
}

export const replaceWhitespaceForHyphen = (str = '') => {
  return str.toString().toLowerCase().replace(/\s+/g, '-')
}

export const slugToText = (slug = '') => {
  return slug.replace(/-/g, ' ')
}

export const pluralize = (num, word, plural = `${word}s`) => ([1, -1].includes(Number(num)) ? word : plural)
